/* eslint-disable prettier/prettier */
/* eslint max-params: off */
import React, { useContext, useEffect, useMemo, useState } from "react";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import "./index.less";
import IconFont from "@/components/icon";
import { useTranslation } from "react-i18next";
import { ChatMessage, ChatMessageType } from "@/types/chat";
import {
  employeeToUid,
  forwardJoySpaceCard,
  MessageCardType,
  forwardLeaveWord,
  selectedSessionsToForward,
  checkisLiveCard,
  checkIsSummaryCard,
  forwardLimitSessionNum
} from "@/utils/chat/message";
import ImDownloadController from "@/baseComponents/Chat/ImCollapsePanel/ImDownloadPanel/BatchDownloadController";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import { FocusSDK, isFocusEnv } from "@/utils";
import get from "lodash/get";
import isString from "lodash/isString";
import ImService from "@/server/ImService";
import { UserModel } from "@/models/user";
import { SessionSettingsType } from "@/types/chat/enum";
import { Button, message, message as toast, Modal } from "antd";
import prompt from "@/baseComponents/ModalComponent/prompt";
import { getSelectorSessions } from "@/utils/chat/session";
import {
  ContactShowType,
  SelectGroupType,
  SelectorMode,
  UserSelTab
} from "@jd/focus-desktop-comps/lib/es/UserSelection";
import debounce from "lodash/debounce";
import { shareJoyspaceFiles } from "@/components/Joyspace/api/page";
import config, { ConfigEnum, getNetCheckUrl } from "@/config/config";
import { InputPlacement } from "@jd/focus-desktop-comps/lib/es/UserSelectionModal/types";
import chatConfig from "@/components/chat/config";
import { analysisLog } from "@/utils/logAnalytics";
import classNames from "classnames";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "@/components/Joyspace/context/events";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import i18n from "@/i18n";
import { isChatPage } from "@/utils/chat/index";
import { getRealConfig } from "@/utils/tools";

interface ForwardingProps {
  messages: any[];
  math: any;
  userData: UserModel;
  teamConfig: any;
  isGroupFileForward?: boolean; // 是否是点击右上角在组文件tab下进行转发操作
  groupMsgs?: any[];
  clearSelectedMsgs: Function;
}
interface DvaDispatchProps {
  deleteSessionMessage: (data: { message: ChatMessage }) => void;
  changeSelectMore: Function;
  updateMessages: (data: { messages: ChatMessage[] }) => void;
}

type IProps = Readonly<ChatState & DvaDispatchProps & ForwardingProps>;

function mapStateToProps({ chat, user: { userData, teamConfig } }: { chat: ChatState; user: any }) {
  const {
    selectMore,
    messages,
    allSessionList,
    currentEmployee,
    selectedSession
  } = chat as ChatState;
  return {
    selectMore,
    messages,
    allSessionList,
    currentEmployee,
    selectedSession,
    userData: userData ? userData.user : {},
    teamConfig
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeSelectMore(data: { selectMore: boolean }) {
      dispatch({ type: "chat/changeSelectMore", payload: data });
    },
    async deleteSessionMessage(data: { message: ChatMessage }) {
      await dispatch({ type: "chat/deleteSessionMessage", payload: data });
    },
    updateMessages(data: { messages: ChatMessage[] }) {
      dispatch({ type: "chat/updateMessages", payload: data });
    }
  };
}

function Forwarding(props: IProps) {
  const {
    changeSelectMore,
    messages,
    allSessionList,
    currentEmployee,
    userData,
    selectedSession,
    deleteSessionMessage,
    updateMessages,
    isGroupFileForward,
    groupMsgs,
    clearSelectedMsgs,
    teamConfig
  } = props;
  const [t] = useTranslation("chat");
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { im } = appRuntimeEnv;
  const limit_session = getRealConfig(teamConfig, im, "forwardlimit_session") || 10;
  const limit_session_single = getRealConfig(teamConfig, im, "forwardlimit_session_single") || 20;
  const limit_messages = getRealConfig(teamConfig, im, "forwardlimit_messages") || 20;
  const download_limit_messages = 10;
  const [msgTotal, setMsgTotal] = useState(0);
  useEffect(() => {
    if (messages.length === limit_messages + 1 && msgTotal === limit_messages) {
      toast.warning("选择消息过多，暂不支持逐条转发，您可选择合并转发");
    }
    setMsgTotal(messages.length);
  }, [limit_messages, messages.length, msgTotal]);
  const cancelSelectMore = () => {
    changeSelectMore({ selectMore: false });
    updateMessages({ messages: [] });
  };
  // 根据是否包含组通知和任务、文档文件夹，来判断是否需要过滤掉跨平台会话
  const includesNoSupport = messages.some(
    (item) =>
      item.type === ChatMessageType.GROUPNOTICE ||
      item.type === ChatMessageType.JOYSPACEFILE ||
      item.type === ChatMessageType.JOYSPACEFOLDER ||
      item.type === ChatMessageType.EGOV_FILE ||
      (item.type === ChatMessageType.TEMPLATE2
        ? item?.template.nativeId === "share_link" &&
          item?.data[0].sharelink?.category === "joywork"
        : false)
  );

  const judgeLiveMessage = () => {
    const includesLiveCard = messages.some((item) => checkisLiveCard(item));
    const allLiveCard = messages.every((item) => checkisLiveCard(item));
    if (allLiveCard) {
      toast.warning(t("live-message-forward-tips"));
      return false;
    }
    if (includesLiveCard) {
      toast.warning(t("live-message-forward-tips"));
    }
    return true;
  };
  const judgeSummaryMessage = () => {
    const includesSummaryCard = messages.some((item) => checkIsSummaryCard(item));
    const allSummaryCard = messages.every((item) => checkIsSummaryCard(item));
    if (allSummaryCard) {
      toast.warning(t("message-forward-tips", { type: "纪要消息" }));
      return false;
    }
    if (includesSummaryCard) {
      toast.warning(t("message-forward-tips", { type: "纪要消息" }));
    }
    return true;
  };
  const judgeVoiceMessage = () => {
    const includesVoice = messages.some((item) => item.type === ChatMessageType.VOICE);
    const allVoice = messages.every((item) => item.type === ChatMessageType.VOICE);
    if (allVoice) {
      toast.warning(t("voice-message-forward-tips"));
      return false;
    }
    if (includesVoice) {
      toast.warning(t("voice-message-forward-tips"));
    }
    return true;
  };
  const isMeetConditions = () => {
    if (isGroupFileForward) {
      if (!groupMsgs || groupMsgs?.length < 1) {
        return false;
      }
      if (groupMsgs?.length > 5) {
        toast.warning("每次最多选择5个文件", 2);
        return false;
      }
    } else {
      if (messages.length < 1) {
        toast.warning(t("please_select_messages"));
        return false;
      }
      if (!judgeVoiceMessage() || !judgeLiveMessage() || !judgeSummaryMessage()) return false;
    }
    return true;
  };
  // 合并转发
  const mergeForwarding = () => {
    if (!isMeetConditions()) return;
    // const fixedUsers = await getSelectorSessions(allSessionList);
    openUserSelectionDefaultModal(
      {
        title: t("select-session-contacts"),
        // fixedUsers: fixedUsers,
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        // mode: SelectorMode.forward,
        mode: SelectorMode.user,
        tabs: ["recentIncludeGroup", "groupCanBeSel"],
        tabSort: [{ tab: UserSelTab.recentIncludeGroup, sort: 1 }],
        // notLoad: isGroupFileForward ? true : false,
        leaveWordInput: {
          maxLength: chatConfig["forward-leave-max-length"],
          placeholder: t("please-enter-forward-leave"),
          isTextArea: true
        },
        inputPlacement: InputPlacement.bodyRightBottom,
        inputWrapClass: "forward-input-wrap",
        contactShowType: includesNoSupport ? ContactShowType.multiTenement : ContactShowType.all,
        // contactsFilterFlag: includesNoSupport ? ["crossPlatform"] : [],
        selectGroupType: includesNoSupport
          ? SelectGroupType.innerAndCrossTenement
          : SelectGroupType.all,
        maxSelectedNum: limit_session,
        maxSelectedSingleNum: limit_session_single,
        isForwardMode: true,
        validate(data) {
          // eslint-disable-next-line no-async-promise-executor
          return new Promise((resolve, reject) => {
            const list = get(data, "data.result", []);
            // if (isGroupFileForward) {
            const canForward = forwardLimitSessionNum(list, limit_session, limit_session_single);
            if (!canForward) {
              toast.warning(`最多支持选择${limit_session_single}个单聊，${limit_session}个群沟通`);
              return;
            }
            // if (list.length > limit_session) {
            //   toast.warning(`最多支持选择${limit_session}个会话`);
            //   return false;
            // }
            // }
            const forwardLeave = get(data, "data.leaveWordInputValue", "");
            if (forwardLeave && forwardLeave.length > chatConfig["forward-leave-max-length"]) {
              toast.info(
                t("content over maxLength", {
                  name: "留言",
                  maxLength: chatConfig["forward-leave-max-length"]
                })
              );
              return false;
            }
            resolve();
          });
        }
      },
      (data, close, update, cancelLoadingFn) => {
        // console.log(data);
        const list = get(data, "data.result", []);
        // console.log('list', list);
        const names = list?.map((item: any) => item.name);
        if (isGroupFileForward) {
          Modal.confirm({
            className: "confirm-modal",
            title: "是否发送给",
            content: names.join("，"),
            icon: undefined,
            centered: true,
            okText: `确认（${names?.length}）`,
            cancelText: "取消",
            onOk(closeModal) {
              return new Promise((resolve, reject) => {
                doExitAndMergeForward(data, close, closeModal);
              });
            },
            onCancel(cancelModal) {
              cancelModal();
              cancelLoadingFn();
            }
          });
        } else {
          doExitAndMergeForward(data, close);
        }
      },
      userData
    );
  };

  const exitAndMergeForward = (options: any, list: any): Promise<Boolean> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const imService = ImService.getInstance();
      const sessionId = selectedSession.sessionId;
      let mids: number[] = [];
      let joyspacePages: any = [];
      let joyspaceFolderPages: any = [];
      const filterMessages = messages
        .filter((item) => item.type !== ChatMessageType.VOICE)
        .filter((item) => !checkisLiveCard(item) && !checkIsSummaryCard(item));
      const msgs: any[] = isGroupFileForward ? groupMsgs || [] : filterMessages;
      msgs.forEach((message) => {
        if (message.type === ChatMessageType.JOYSPACEFILE) {
          joyspacePages.push(message.fileId);
        } else if (message.type === ChatMessageType.JOYSPACEFOLDER) {
          joyspaceFolderPages.push(message.fileId);
        } else if (message.type === ChatMessageType.TEXT && message.displayContent) {
          for (let item of message.displayContent) {
            if (item.type === MessageCardType.JoyspaceTopic) {
              const ext = JSON.parse(item?.ext || "{}");
              joyspacePages.push(ext.pageId);
            }
          }
        }
        mids.push(message.mid);
      });
      const result = await imService.mergeForwardMessage(sessionId, mids, options);
      if (isString(result) && result === SessionSettingsType.BANNED_POST) {
        // return toast.warn(t('banned_post_tip'));
        toast.warn(t("banned_post_tip"));
        resolve(false);
      }
      if (result) {
        if (joyspacePages.length > 0 || joyspaceFolderPages.length > 0) {
          // 合并转发文档授权
          let users: Array<any> = [];
          let groups: Array<any> = [];
          (options.uids || []).forEach((user: any) => {
            users.push({
              userId: user.pin,
              teamId: user.teamId,
              permission_type: 2
            });
          });
          (options.gids || []).forEach((id: any) => {
            groups.push({ gid: id, permission_type: 2 });
          });
          shareJoyspaceFiles({
            page_ids: joyspacePages,
            folder_ids: joyspaceFolderPages,
            to_eepaas_users: users,
            to_groups: groups
          });
        }
        if (isGroupFileForward) {
          clearSelectedMsgs();
        } else {
          updateMessages({ messages: [] });
          changeSelectMore({ selectMore: false });
        }
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  const doExitAndMergeForward = debounce(async (data: any, cb, closeModal?) => {
    console.log("doExitAndMergeForward=>", JSON.parse(JSON.stringify(data)));
    // 等待合并转发消息处理完成以后，再关闭人员选择器窗口
    const list = get(data, "data.result", []);
    if (!list || list.length <= 0) {
      return;
    }
    const options = await selectedSessionsToForward(list);
    console.log("多选合并转发", data, options);
    const status = await exitAndMergeForward(options, list);
    if (status) {
      const forwardLeave = get(data, "data.leaveWordInputValue", "");
      console.log("forwardLeave=>", forwardLeave);
      // console.log(forwardLeave);
      forwardLeave && (await forwardLeaveWord(currentEmployee, options, forwardLeave));
      toast.success(t("forwarding-successful"));
    } else {
      toast.error(t("forwarding-failed"));
    }
    closeModal?.();
    cb();
  }, 500);

  // 逐条转发
  const listsForwarding = () => {
    if (!isMeetConditions()) return;
    if (!isGroupFileForward && messages.length > limit_messages) {
      return;
    }
    // const fixedUsers = await getSelectorSessions(allSessionList);
    openUserSelectionDefaultModal(
      {
        title: t("select-session-contacts"),
        // fixedUsers: fixedUsers,
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        // mode: SelectorMode.forward,
        mode: SelectorMode.user,
        // notLoad: isGroupFileForward ? true : false,
        tabs: ["recentIncludeGroup", "groupCanBeSel"],
        tabSort: [{ tab: UserSelTab.recentIncludeGroup, sort: 1 }],
        leaveWordInput: {
          maxLength: chatConfig["forward-leave-max-length"],
          placeholder: t("please-enter-forward-leave"),
          isTextArea: true
        },
        inputPlacement: InputPlacement.bodyRightBottom,
        inputWrapClass: "forward-input-wrap",
        contactShowType: includesNoSupport ? ContactShowType.multiTenement : ContactShowType.all,
        // contactsFilterFlag: includesNoSupport ? ["crossPlatform"] : [],
        selectGroupType: includesNoSupport
          ? SelectGroupType.innerAndCrossTenement
          : SelectGroupType.all,
        maxSelectedNum: limit_session,
        maxSelectedSingleNum: limit_session_single,
        isForwardMode: true,
        validate(data) {
          return new Promise((resolve, reject) => {
            const list = get(data, "data.result", []);
            const canForward = forwardLimitSessionNum(list, limit_session, limit_session_single);
            if (!canForward) {
              toast.warning(`最多支持选择${limit_session_single}个单聊，${limit_session}个群沟通`);
              return;
            }
            // if (isGroupFileForward) {
            // if (list.length > limit_session) {
            //   toast.warning(`最多支持选择${limit_session}个会话`);
            //   return false;
            // }
            // }
            const forwardLeave = get(data, "data.leaveWordInputValue", "");
            if (forwardLeave && forwardLeave.length > chatConfig["forward-leave-max-length"]) {
              toast.info(
                t("content over maxLength", {
                  name: "留言",
                  maxLength: chatConfig["forward-leave-max-length"]
                })
              );
              return false;
            }
            resolve();
          });
        }
      },
      (data, close, update, cancelLoadingFn) => {
        console.log("点击了确定");
        const list = get(data, "data.result", []);
        // console.log('list', list);
        const names = list?.map((item: any) => item.name);
        if (isGroupFileForward) {
          Modal.confirm({
            className: "confirm-modal",
            title: "是否发送给",
            content: names.join("，"),
            icon: undefined,
            centered: true,
            okText: `确认（${names?.length}）`,
            cancelText: "取消",
            onOk(closeModal) {
              return new Promise((resolve, reject) => {
                doExitAndForward(data, close, closeModal);
              });
            },
            onCancel(cancelModal) {
              cancelModal();
              cancelLoadingFn();
            }
          });
        } else {
          doExitAndForward(data, close);
        }
      },
      userData
    );
  };
  const exitAndForward = (options: any, list: any): Promise<Boolean> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const imService = ImService.getInstance();
      const sessionId = selectedSession.sessionId;
      let forwardAll = true;
      const filterMessages = messages
        .filter((item) => item.type !== ChatMessageType.VOICE)
        .filter((item) => !checkisLiveCard(item) && !checkIsSummaryCard(item));
      const msgs: any[] = isGroupFileForward ? groupMsgs || [] : filterMessages;
      let body: any = {};
      for (let message of msgs) {
        // TODO 逐条转发
        body = await forwardJoySpaceCard(message, options, message.type);
        const result = await imService.forwardMessage(sessionId, message, options, body);
        if (isString(result) && result === SessionSettingsType.BANNED_POST) {
          forwardAll = false;
          // return toast.warn(t('banned_post_tip'));
          toast.warn(t("banned_post_tip"));
          resolve(false);
        }
        if (!result) {
          resolve(false);
        }
      }
      if (forwardAll) {
        // toast.success(t('forwarding-successful'));
        if (isGroupFileForward) {
          clearSelectedMsgs();
        } else {
          updateMessages({ messages: [] });
          changeSelectMore({ selectMore: false });
        }
        resolve(true);
      }
    });
  };

  const doExitAndForward = debounce(async (data: any, cb, closeModal?) => {
    const list = get(data, "data.result", []);
    if (!list || list.length <= 0) {
      return;
    }
    const options = await selectedSessionsToForward(list);
    console.log("多选逐条转发", data, options);
    const status = await exitAndForward(options, list);
    if (status) {
      const forwardLeave = get(data, "data.leaveWordInputValue", "");
      // console.log(forwardLeave);
      forwardLeave && (await forwardLeaveWord(currentEmployee, options, forwardLeave));
      toast.success(t("forwarding-successful"));
    } else {
      toast.error(t("forwarding-failed"));
    }
    closeModal?.();
    cb();
  }, 500);

  // 删除
  const deleteMessages = () => {
    if (messages.length < 1) {
      toast.warning(t("please_select_messages"));
      return;
    }
    // 删除提醒
    prompt({
      title: t("delete-reminder"),
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      onCancel: () => {
        analysisLog("Xtbg_Msg", "InfoMultiDelete_Cancel");
      },
      onOk: async () => {
        // 调用删除接口
        analysisLog("Xtbg_Msg", "InfoMultiDelete_Confirm");
        let deleteAll = true;
        for (let message of messages) {
          const imService = ImService.getInstance();
          const result = await imService.deleteMessage(message);
          if (result) {
            // 删除 dva 中的 数据
            deleteSessionMessage({ message: message });
          } else {
            deleteAll = false;
            toast.error(t("deletion-failed"));
            return;
          }
        }
        if (deleteAll) {
          toast.success(t("deletion-succeeded"));
          updateMessages({ messages: [] });
          changeSelectMore({ selectMore: false });
        }
      },
      content: t("delete-selected-message"),
      okText: t("determine"),
      cancelText: t("cancelText")
    });
  };
  const limitclasses = useMemo(() => {
    return classNames({
      "limit-forward": messages.length > limit_messages,
      "lists-forwarding": true
    });
  }, [limit_messages, messages.length]);
  const limitclasses_icon = useMemo(() => {
    return classNames({
      "limit-forward-icon": messages.length > limit_messages,
      icon: true
    });
  }, [limit_messages, messages.length]);

  const listsDownloading = async () => {
    if (isChatPage()) {
      toast.error(i18n.t("operate in main window"));
      return;
    }
    if (groupMsgs && groupMsgs.length > download_limit_messages) {
      toast.error("最多支持下载10个文件");
      return;
    }
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl(),
      checkType: UseCheckType.API
    });
    const onLine = await netServer.checkNet();
    if (!onLine) {
      return toast.error(i18n.t("Network Error"));
    }
    analysisLog("xtbg_pc_im_batch_download_1715679987198", "1");
    if (isFocusEnv()) {
      ImDownloadController.getInstance()?.chooseDownloadPage((path: string) => {
        if (groupMsgs) {
          const list = groupMsgs.map((item) => ({
            ...item,
            path
          }));
          FocusSDK.handleImAddDownloadTaskList(list);
        }
      });
    } else {
      events.emit("handleImDownload:addTaskList", groupMsgs);
    }
    clearSelectedMsgs();
  };

  if (isGroupFileForward) {
    return (
      <div className="group-file-btn-wrapper">
        {isFocusEnv() ? (
          <Button
            type="primary"
            onClick={debounce(listsDownloading, 500)}
            clstag="pageclick|keycount|Xtbg_Msg|InfoMultiListDownload"
          >
            {t("lists_downloading")}
          </Button>
        ) : (
          <div />
        )}
        <div className="group-file-btn-end">
          <Button
            type="primary"
            onClick={debounce(listsForwarding, 500)}
            clstag="pageclick|keycount|Xtbg_Msg|InfoMultiListForward"
          >
            {t("lists_forwarding")}
          </Button>
          <Button
            type="primary"
            onClick={debounce(mergeForwarding, 500)}
            clstag="pageclick|keycount|Xtbg_Msg|InfoMultiMergeForward"
          >
            {t("merge_forwarding")}
          </Button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="forwarding">
        <div className="operate">
          <div className={limitclasses}>
            {/* 如果选择的消息条数超过20条，按钮置灰，toast提示 */}
            <span
              onClick={listsForwarding}
              clstag="pageclick|keycount|Xtbg_Msg|InfoMultiListForward"
            >
              <IconFont className={limitclasses_icon} type="iconapp_btn_forwarding1" />
            </span>
            <span>{t("lists_forwarding")}</span>
          </div>

          <div
            className="merge-forwarding"
            clstag="pageclick|keycount|Xtbg_Msg|InfoMultiMergeForward"
          >
            <span onClick={mergeForwarding}>
              <IconFont className="icon" style={{ fontSize: "16px" }} type="iconapp_btn_merge" />
            </span>
            <span>{t("merge_forwarding")}</span>
          </div>

          <div className="delete">
            <span onClick={deleteMessages} clstag="pageclick|keycount|Xtbg_Msg|InfoMultiDelete">
              <IconFont className="icon" type="iconapp_ic_delete" />
            </span>
            <span>{t("delete")}</span>
          </div>
        </div>
        <div className="cancel">
          <div>
            <span>
              {t("userSelection.hasSelected")}（{messages.length || 0}）
            </span>
          </div>
          <div onClick={cancelSelectMore} clstag="pageclick|keycount|Xtbg_Msg|InfoCancelMulti">
            <span>{t("cancelText")}</span>
            <span>
              <IconFont className="icon" type="iconapp_btn_file_cancel" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Forwarding);
